import React from 'react'
import LookUpsMain from '../../components/admin-component/lookups/LookUpsMain'

const Lookup = () => {
  return (
    <LookUpsMain/>
  )
}

export default Lookup